import { Close, FullscreenExit } from '@material-ui/icons';
import React from 'react'
import RcButton from '../UiUtilities/Button';

function CompactViewHeader({closeFullscreen, mode} : {closeFullscreen: () => void; mode: string}) {
  return (
    <div className={`compact-view-close ${mode === 'light' ? "light" : "dark"}`}>
        <h2 className='sa-nav-header-text notranslate' style={{margin: 0, marginLeft: 20, color: 'white'}}>
            Shadow Agent
        </h2>
        <RcButton onClick={() => closeFullscreen()} style={{marginRight: 10, display: 'flex', alignItems: 'center'}}>
            <span style={{color: "White", marginRight: 5}}>Exit full screen </span><FullscreenExit style={{color: 'white'}} />
        </RcButton>
    </div>
  )
}

export default CompactViewHeader